import script from "./AboutEn.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutEn.vue?vue&type=script&setup=true&lang=js"

import "./AboutEn.vue?vue&type=style&index=0&id=9f3a9776&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9f3a9776"]])

export default __exports__